/**
 * Returns the set of user IDs (strings) that were participants in the most recent
 * default-bill statement that the current user created (owner).
 * Used to default the participant list in Quick Split and Add Default Statement flows.
 * @param {{ statements: Array<{ id: string, owner_id?: string, created_at: string }>, transactions: Array<{ statement_id?: string, user_id: string }> } | undefined} defaultBillData
 * @param {string} currentUserId - Current user's internal user id (UUID string)
 * @returns {string[]}
 */
export default function getLastDefaultStatementParticipantIds(defaultBillData, currentUserId) {
    const statements = defaultBillData?.statements ?? [];
    const transactions = defaultBillData?.transactions ?? [];
    if (!statements.length || !currentUserId) return [];

    const ownedByMe = statements.filter(
        (s) => (s.owner_id ?? s.ownerId) === currentUserId
    );
    if (!ownedByMe.length) return [];

    const sorted = [...ownedByMe].sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
    );
    const lastStatementId = sorted[0]?.id;
    if (!lastStatementId) return [];

    const seen = new Set();
    const userIds = [];
    for (const t of transactions) {
        const stmtId = t.statement_id ?? t.statementId;
        if (stmtId !== lastStatementId) continue;
        const uid = t.user_id ?? t.userId ?? t.user?.id;
        if (uid && !seen.has(uid)) {
            seen.add(uid);
            userIds.push(uid);
        }
    }
    return userIds;
}
